module.exports = __webpack_public_path__ + "img/pic-NARISAWA.28856336.png";